import Swiper, { Navigation } from "swiper";
Swiper.use([Navigation]);

document.addEventListener("DOMContentLoaded", () => {
  const sliderContainer = document.querySelector(
    ".examples_of_calculations__wrapper__list"
  );
  if (!sliderContainer) return;

  const prevButton = document.querySelector(
    ".examples_of_calculations__wrapper__list__control--prev"
  );
  const nextButton = document.querySelector(
    ".examples_of_calculations__wrapper__list__control--next"
  );

  const swiper = new Swiper(".examples_of_calculations__wrapper__list", {
    slidesPerView: 1,
    spaceBetween: 30,
    autoHeight: false,
     watchSlidesProgress: true,
    navigation: {
      nextEl: nextButton || undefined,
      prevEl: prevButton || undefined,
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        allowTouchMove: false,
        simulateTouch: false,
      },
    },
  });
});
